@if (users) {
  @for (user of users; track user; let i = $index) {
    <span class="user-blob color-{{i % 4}}" title="{{user.first}} {{user.last}} <{{user.email}}>">
      {{user.first[0].toUpperCase()}}{{user.last[0].toUpperCase()}}
    </span>
  }
  @if (overflow > 0) {
    <span class="user-blob overflow">
      +{{overflow}}
    </span>
  }
}
